<template>
  <div class="doctor-details-container">
    <div class="doctor-image-section">
      <div class="header">
        <button class="back-button ps-4" @click="goBack">
          <i class="pi pi-chevron-left"></i>
        </button>
      </div>
      <img :src="doctor.image" alt="Doctor Image" class="doctor-image" />
    </div>
    <div class="details-frame">
      <div class="doctor-info">
        <h2 class="doctor-name">{{ doctor.name }}</h2>
        <p class="doctor-specialty">{{ doctor.specialty }}</p>
        <div class="doctor-rating">
          <i class="pi pi-star-fill"></i>
          <i class="pi pi-star-fill"></i>
          <i class="pi pi-star-fill"></i>
          <i class="pi pi-star-fill"></i>
          <i class="pi pi-star-fill"></i>
          <span class="review-count">(2344 отзывов)</span>
        </div>
      </div>

      <div style="border-bottom: 1px solid #e0e0e0"></div>
      <div class="about-section">
        <h3>Информация о враче</h3>
        <p>{{ doctor.description }}</p>
      </div>

      <!-- Appointment Button -->
      <div class="d-grid px-2 py-3 py-md-5">
        <Button
          label="Записаться на прием"
          severity="success"
          rounded
          raised
          @click="showDialog"
        />
      </div>
    </div>
    <Dialog
      v-model:visible="dialogVisible"
      modal
      :showHeader="false"
      :style="{ width: '300px', borderRadius: '8px' }"
      :pt="{
        root: { class: 'text-center success-dialog' },
        content: { class: 'text-center p-4' },
      }"
    >
      <div class="success-icon mb-3">
        <i class="pi pi-check"></i>
      </div>
      <h3 class="mb-2">Спасибо!</h3>
      <p class="text-secondary mb-4">Ваша заявка на запись к врачу принята.</p>
      <Button
        label="OK"
        @click="dialogVisible = false"
        severity="success"
        rounded
        style="width: 100%"
      />
    </Dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Dialog from "primevue/dialog";

export default defineComponent({
  name: "DoctorProfilePage",
  components: {
    Dialog,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const doctorsData = [
      {
        id: 1,
        name: "Чащин\nМихаил Георгиевич",
        specialty: "Заведующий отделением, кардиолог-липидолог",
        scstatus: "к.м.н.",
        reviews: 120,
        experience: 10,
        patients: 1000,
        rating: 4.5,
        image: require("@/assets/MCH.jpg"),
        description:
          "Опытный специалист с 10-летним стажем работы в кардиологии. Специализируется на лечении сердечно-сосудистых заболеваний и нарушений липидного обмена.",
      },
      {
        id: 2,
        name: "Глечян\nАнуш Михайловна",
        specialty: "Кардиолог-липидолог",
        scstatus: "к.м.н.",
        reviews: 85,
        experience: 12,
        patients: 1100,
        rating: 4.0,
        image: require("@/assets/GL.jpg"),
        description:
          "Доктор имеет 12 лет опыта в кардиологии, специализируется на диагностике и лечении артериальной гипертензии и ишемической болезни сердца.",
      },
      {
        id: 3,
        name: "Емельянов\nАлександр Владимирович",
        specialty: "Кардиолог-липидолог",
        scstatus: "высшая категория",
        reviews: 120,
        experience: 30,
        patients: 900,
        rating: 4.04,
        image: require("@/assets/EM.jpg"),
        description:
          "Опытный специалист с 30-летним стажем работы в кардиологии. Специализируется на лечении сердечно-сосудистых заболеваний и нарушений липидного обмена.",
      },
      // ... остальные врачи ...
    ];

    const doctor = ref({});
    const dialogVisible = ref(false);

    onMounted(() => {
      const selectedDoctor = doctorsData.find(
        (d) => d.id === Number(route.params.id)
      );
      if (selectedDoctor) {
        doctor.value = selectedDoctor;
      }
    });

    const goBack = () => {
      router.push({ name: "DoctorsPage" });
    };

    const showDialog = () => {
      dialogVisible.value = true;
    };

    return { doctor, goBack, dialogVisible, showDialog };
  },
});
</script>

<style scoped>
/* General Container */
.doctor-details-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f9fa;
  height: 100vh;
}

/* Top Section: Doctor Image */
.doctor-image-section {
  position: relative;
  width: 100%;
  height: 45vh;
  background-color: #4caf50;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.doctor-image-section img {
  width: 100%;
  /*   height: 100%; */
  object-fit: cover;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 0px;
  background: transparent;
  border: none;
  font-size: 20px;
  color: #4caf50;
  cursor: pointer;
}

/* Rounded Frame Section */
.details-frame {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  padding: 20px;
  margin-top: -40px;
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  border-radius: 30px;
  top: -10px;
  position: relative;
}

/* Doctor Info */
.doctor-info {
  margin-bottom: 20px;
}

.doctor-name {
  font-size: 20px;
  font-weight: bold;
  margin: 5px 0;
}

.doctor-specialty {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.doctor-rating {
  display: flex;
  justify-content: left;
  align-items: left;
  gap: 5px;
  font-size: 14px;
}

.doctor-rating .pi-star-fill {
  color: #ffc107;
}

.review-count {
  color: #666;
  font-size: 14px;
}

/* Contact Options */
.contact-options {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 20px 0;
}

.contact-button {
  width: 50px;
  height: 50px;
  background-color: #4caf50;
  border-radius: 50%;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.contact-button.email {
  background-color: #ff9800;
}

.see-reviews {
  font-size: 14px;
  color: #4caf50;
  text-decoration: none;
  margin-left: 10px;
}

/* About Section */
.about-section {
  margin: 20px 0;
}

.about-section h3 {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: left;
}

.about-section p {
  font-size: 14px;
  color: #666;
  text-align: left;
}

.about-section .see-more {
  font-size: 14px;
  color: #4caf50;
  text-decoration: none;
}

/* Appointment Button */
.appointment-button {
  width: 90%;
  padding: 15px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.success-dialog {
  border-radius: 8px;
}

.success-icon {
  width: 60px;
  height: 60px;
  background-color: #4caf50;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.success-icon i {
  color: white;
  font-size: 30px;
}

.success-dialog h3 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.success-dialog p {
  color: #666;
  margin: 0;
}

:deep(.p-dialog-mask) {
  backdrop-filter: blur(2px);
  background-color: rgba(0, 0, 0, 0.4);
}
</style>
